const firebaseConfig = {
    apiKey: "AIzaSyDPi4pT4Nk8jrla_L_AKZfB3EKgf-I2GJE",
    authDomain: "info-crypto.firebaseapp.com",
    projectId: "info-crypto",
    storageBucket: "info-crypto.appspot.com",
    messagingSenderId: "926333838310",
    appId: "1:926333838310:web:d3d73bfbb157bd714bac27"
  };

  export default firebaseConfig;